export default "__VITE_ASSET__$AdUOLwJ__"